import { Form, Input, message, Modal } from 'antd';
import React, { useState } from 'react';
import Api from '../../../../api/Api';

type PrivateProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  afterSignUp?: () => void
};

export default function SignUp({open, setOpen, afterSignUp}: PrivateProps) {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setConfirmLoading(true);
      const data: any = await Api.auth.signUp(values);
      if (data) {
        setConfirmLoading(false);
        form.resetFields();
        setOpen(false);
        message.success(
          'Request for the registration has been performed successfully! An activation email will be sent to you shortly. Please check your email to complete a registration.',
          10
        );
        if (afterSignUp) {
          afterSignUp();
        }
      }
    }
    catch {
      setConfirmLoading(false);
    }
    finally {
      setConfirmLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setOpen(false);
  };

  return (
    <>
      <Modal
        title="Registration"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>We will send you a registration link on the email provided below</p>
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
          initialValues={{ modifier: 'public' }}
        >
          <Form.Item
            name="email"
            label="E-mail"
            rules={[
              {
                type: 'email',
                message: 'The input is not valid E-mail!',
              },
              {
                required: true,
                message: 'Please input your E-mail!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
